export const WebSocketEventsMap = {
  Assignment: {
    PROGRESS_UPDATE: 'assignment:progress:update',
    CANNOT_REINTENT: 'assignment:cannot_reintent',
    FINISHED: 'assignment:finished',
    ERROR: 'assignment:error',
    ORDER_ASSIGNED: 'assignment:order:assigned',
    ORDERS_COUNT: 'assignment:orders:count',
    PARENT_READY: 'assignment:parent:ready',
  },
  Labels: {
    DOWNLOAD_PROGRESS: 'labels:download:progress',
  },
  Report: {
    EXPORT_READY: 'report:export:ready',
    EXPORT_PROGRESS: 'report:export:progress',
  },
  AddressExport: {
    COMPLETE: 'address-export:complete',
    FAILED: 'address-export:failed',
  },
  Checkout: {
    PAYMENT_STATUS: 'checkout:payment:status',
  },
  Client: {
    SUBSCRIBE: 'client:subscribe',
    UNSUBSCRIBE: 'client:unsubscribe',
  },
};
